import React from "react";
import { UnVerifiedEmailScreenContainer } from "../../../containers";

export const UnVerifiedEmailScreen = () => {
  return <UnVerifiedEmailScreenContainer />;
};
